import { Stack, styled, Theme } from '@mui/material';
import Logo from '../../../assets/icons/logo.svg?react';
import { LogoutButton } from '../../common/Button/LogoutButton/LogoutButton';
import { isBrowser } from 'react-device-detect';

import { SupportWidget } from '../../features/SupportWidget/SupportWidget';
import { CabinetNotificationBell } from '../../features/CabinetNotificationBell/CabinetNotificationBell';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';

const StyledHeader = styled('header')(() => ({
  position: 'fixed',
  top: 0,
  right: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  zIndex: 10,
  paddingTop: 0,
  backgroundColor: '#353434',
}));

export const Header = ({ fullBleed = false }: { fullBleed?: boolean } = {}) => {
  const { pathname } = useLocation();

  const renderLogoutButton = () => {
    if (pathname === `/${ROUTES.CABINET}/${ROUTES.CAB_PROFILE}`)
      return <LogoutButton />;
    return null;
  };
  return (
    <StyledHeader>
      <Stack
        sx={(theme: Theme) => ({
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          justifyContent: 'space-between',
          maxWidth: fullBleed ? '100%' : !isBrowser ? '100%' : '400px',
          width: '100%',
          padding: '15px 22px',
          backgroundColor: theme.palette.gray[300],
        })}
      >
        <Logo />
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ marginLeft: 'auto', gap: '21px', alignItems: 'center' }}
        >
          <CabinetNotificationBell />
          <SupportWidget />
          {renderLogoutButton()}
        </Stack>
      </Stack>
    </StyledHeader>
  );
};
